import { Info, TrendingDown, TrendingUp } from 'lucide-react'

import { formatearVariacionPct } from '../../../utils/analiticaPos'

// Tarjeta de métrica reutilizada en todos los bloques de Analítica POS.
// `variacionPct`: null/undefined -> no se muestra comparación (sin
// período anterior comparable). `tooltip`: texto corto con la fórmula,
// mostrado vía `title` nativo sobre el ícono de información — sin
// dependencias nuevas.
function MetricCard({ etiqueta, valor, subvalor, variacionPct, tooltip, destacado = false }) {
  const variacionTexto = formatearVariacionPct(variacionPct)
  const esPositiva = Number(variacionPct) > 0
  const esNegativa = Number(variacionPct) < 0

  return (
    <div
      className={`rounded-2xl border p-4 shadow-sm ${
        destacado
          ? 'border-emerald-200 bg-emerald-50'
          : 'border-slate-200 bg-white'
      }`}
    >
      <div className="flex items-center gap-1.5">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          {etiqueta}
        </p>

        {tooltip && (
          <span title={tooltip} className="cursor-help text-slate-400">
            <Info size={13} />
          </span>
        )}
      </div>

      <p className="mt-1.5 truncate text-xl font-bold text-slate-900">
        {valor}
      </p>

      {subvalor && (
        <p className="mt-0.5 truncate text-xs text-slate-500">{subvalor}</p>
      )}

      {variacionTexto && (
        <p
          className={`mt-1.5 flex items-center gap-1 text-xs font-semibold ${
            esPositiva
              ? 'text-emerald-600'
              : esNegativa
                ? 'text-red-600'
                : 'text-slate-500'
          }`}
        >
          {esPositiva && <TrendingUp size={13} />}
          {esNegativa && <TrendingDown size={13} />}
          {variacionTexto} vs. período anterior
        </p>
      )}
    </div>
  )
}

export default MetricCard
